import { Controller } from "@hotwired/stimulus";

// Generic controller for opening modals in pagepushers
export default class extends Controller {
  // Action to open a modal
  // Usage: data-action="click->pagepusher-modal#openModal"
  //        data-modal-id="update_proposal"
  //        data-form-action="/path/to/action" (optional)
  //        data-field-id="element_id" (optional)
  //        data-field-value="value" (optional)
  //        data-tinymce-id="editor_id" (optional)
  //        data-htmx-url="/path/to/content" (optional - load content via HTMX)
  //        data-htmx-target="#target-id" (optional - where to load HTMX content)
  openModal(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const modalId = button.dataset.modalId;
    const formAction = button.dataset.formAction;
    const fieldId = button.dataset.fieldId;
    const fieldValue = button.dataset.fieldValue;
    const tinymceId = button.dataset.tinymceId;
    const htmxUrl = button.dataset.htmxUrl;
    const htmxTarget = button.dataset.htmxTarget;

    if (!modalId) {
      return;
    }

    const modal = document.getElementById(modalId);
    if (!modal) {
      return;
    }

    // Load dynamic content via HTMX if URL provided
    if (htmxUrl && htmxTarget && typeof htmx !== 'undefined') {
      htmx.ajax('GET', htmxUrl, { target: htmxTarget, swap: 'innerHTML' });
    }

    if (formAction) {
      const form = modal.querySelector('form');
      if (form) {
        form.setAttribute('action', formAction);
      }
    }

    if (fieldId) {
      const field = document.getElementById(fieldId);
      if (field && typeof $ !== 'undefined') {
        $(field).val(fieldValue !== undefined ? fieldValue : '');
      }
    }

    if (tinymceId) {
      this.initTinyMCE(tinymceId, modalId);
    }

    new bootstrap.Modal(modal).show();
  }

  initTinyMCE(editorId, modalId) {
    if (typeof tinyMCE !== 'undefined' &&
        typeof initTinyMCENoToolbar !== 'undefined' &&
        !tinyMCE.get(editorId)) {
      initTinyMCENoToolbar(`#${modalId} #${editorId}`);
    }
  }

  // Transition from one modal to another
  // This is used on the SOW show page to transition from the accept sow modal to the negotiation modal
  // Usage: data-action="click->pagepusher-modal#transitionModal"
  //        data-from-modal-id="purchase_dialog"
  //        data-to-modal-id="auto_negotiation"
  //        data-field-id="auto_negotiation_sow_uuid" (optional)
  //        data-field-value="proposal-uuid" (optional)
  transitionModal(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const { fromModalId, toModalId, fieldId, fieldValue } = button.dataset;

    // Close first modal, then open second
    const fromModal = bootstrap.Modal.getInstance(document.getElementById(fromModalId));
    const toModalElement = document.getElementById(toModalId);

    if (fromModal) {
      document.getElementById(fromModalId).addEventListener('hidden.bs.modal', () => {
        setTimeout(() => {
          // Set field value if specified
          if (fieldId && fieldValue !== undefined) {
            const field = document.getElementById(fieldId);
            if (field && typeof $ !== 'undefined') {
              $(field).val(fieldValue);
            }
          }
          new bootstrap.Modal(toModalElement).show();
        }, 150);
      }, { once: true });
      fromModal.hide();
    } else {
      new bootstrap.Modal(toModalElement).show();
    }
  }
}
